module.exports = {
  TABLE_ID:{
    DEVICE_EMBEDDED_INFORMATION:1,
    CERTIFICATE_INFORMATION:2,
    APPROVAL_HISTORY:3,
    DEVICE_EMBEDDED_DETAIL:4,
    ASSOCIATED_DEVICE:5,
    USER:6,
    TEMP_BATCH_IMPORT:7,
    CERTIFICATE:8,
    CERTIFICATE_SOFTWARE:9,
    MAIL_MESSAGE:60,
    BELONGS:70,
    SYSTEM:80,
    MAKER:90,
    SOFTWARE:100,
    INVENTORY_REPORTING_PERIOD:110,
    INVENTORY:120,
    APPLICATION_FLOW_CERTIFICATE_SOFTWARE:51,
    APPLICATION_FLOW_DEVICE_EMBEDDED_INFORMATION:52,
  },
  SYUBETU:{
    DEVICE:"機器・組込情報",
    CERTIFICATE:"証書情報",
    DEVICE_DETAIL:"組込情報",
    ASSOCIATED_DEVICE:"ソフトウェア情報",
    USER:"ユーザ",
    BATCH_IMPORT:"一括取込",
    INVENTORY:"棚卸"
  },
  SOFTWARE_JURISDICTION:{
    OWN_DEPARTMENT :"当該部署所管", // 自部署所管
    OTHER_DEPARTMENT :"他部署所管", // IT所管
    PRE_INSTALL :"プレインストール",
    LEASING_AND_RENTAL:"リース/レンタル"
  },
  USER_STATUS:{
    ACTIVE:1,
    BLOCKED:9
  },
  COMPANY:{
    ALL:"ライセンス管理窓口",
    MHFG:"MHFG",
    MHBK:"MHBK",
    MHTB:"MHTB"
  },
  PERMISSION:{
    ID_OPERATIONS_PERSONNEL: "ユーザIDオペレーション担当者",
    ADMINISTRATOR: "管理担当者",
    CHIEF_ADMINISTRATOR: "管理責任者",
    SYSTEM_ADMINISTRATOR: "システム管理者",
    MAINTENANCE_STAFF: "保守担当",
    NONE:'none'
  },
  PERMISSION_MODE:{
    BROWSE:"browse",
    ADD:"add",
    EDIT:"edit",
    DELETE:"delete",
    EXPORT:"export"
  },
  HISTORY_MODE:{
    NEW:1,
    UPDATE:2,
    DELETE:3,
    UPDATE_APPLICATION:4
  },
  COMMON:{
    ALL_USERS_LABEL : "全ユーザ",
    ALL_USERS_VALUE:"all_users"
  },
  INVENTORY:{
    INVENTORY_APPROVAL_Number : 20
  }
}



// WEBPACK FOOTER //
// ./src/rules/constants.js